import { Component, Input, OnInit } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";

import { combineLatest } from "rxjs";
import { first } from "rxjs/operators";

import { NoteBruger, NoteHenvendelsestype, NoteOmraade, NoteOpgavestyringStatus } from "@e-forsyning/common/note";

import { MaalerskiftNoteService } from "./batteriskift-note.service";

@Component({
    selector: "batteriskift",
    templateUrl: "./batteriskift.component.html",
    styleUrls: ["./batteriskift.component.scss"]
})
export class BatteriskiftComponent implements OnInit {
    @Input() public formGroup: UntypedFormGroup;

    public defaultNoteOmraadeId: number;
    public noteOmraader: NoteOmraade[];
    public noteHenvendelsestyper: NoteHenvendelsestype[];
    public noteOpgavestyringStatusser: NoteOpgavestyringStatus[];
    public noteBrugere: NoteBruger[];

    constructor(private readonly noteService: MaalerskiftNoteService) {}

    public ngOnInit(): void {
        this.defaultNoteOmraadeId = this.noteService.defaultNoteOmraadeId;
        const noteOmraader$ = this.noteService.hentNoteOmraader();
        const noteHenvendelsestyper$ = this.noteService.hentNoteHenvendelsestyper();
        const noteOpgavestyringStatusser$ = this.noteService.hentNoteOpgavestyringStatusser();
        const noteBrugere$ = this.noteService.hentNoteBrugere();

        combineLatest([noteOmraader$, noteHenvendelsestyper$, noteOpgavestyringStatusser$, noteBrugere$])
            .pipe(first())
            .subscribe((result) => {
                this.noteOmraader = result[0];
                this.noteHenvendelsestyper = result[1];
                this.noteOpgavestyringStatusser = result[2];
                this.noteBrugere = result[3];
            });
    }

    public onInitialiserNotePaaGammelMaaler(noteFormGroup: UntypedFormGroup, maalerNr: string): void {
        noteFormGroup.get("overskrift").setValue(`Batteriskift på måler: ${maalerNr}`);
    }
}
